var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFuerzaOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.12 199.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff7f00;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-fuerza-off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_15",
    "data-name": 15
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1.08 113.7 1.08 131.97 170.19 131.97 134.38 113.7 1.08 113.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "255.12 154.78 174.58 113.7 134.38 113.7 172.38 113.7 172.38 131.97 170.19 131.97 240.57 167.87 255.12 154.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "172.38 113.7 134.38 113.7 170.19 131.97 172.38 131.97 172.38 113.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.84,166.22a31.67,31.67,0,0,0-3.73-13.41,32,32,0,0,0-56.47,0,31.68,31.68,0,0,0-3.74,13.41c0,.55,0,1.1,0,1.65a32,32,0,0,0,64,0C123.89,167.32,123.87,166.77,123.84,166.22Zm-32,22.16a20.51,20.51,0,0,1-20.51-20.51c0-.56,0-1.1.07-1.65a20.51,20.51,0,0,1,40.88,0c0,.55.07,1.09.07,1.65A20.51,20.51,0,0,1,91.87,188.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.08,132a36.22,36.22,0,0,1,15.08,15,35.75,35.75,0,0,1,4.22,15.17c0,.62.05,1.24.05,1.86a34.75,34.75,0,0,1-.21,3.84h33.36V132Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.32,164c0-.62,0-1.24,0-1.86A36.2,36.2,0,0,1,68.67,132H1.08v35.85H49.52A37.39,37.39,0,0,1,49.32,164Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.11 131.97 36.85 131.97 43.88 113.7 62.14 113.7 55.11 131.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.27 131.97 0 131.97 7.03 113.7 25.3 113.7 18.27 131.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.59 131.97 74.32 131.97 81.35 113.7 99.62 113.7 92.59 131.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.66 131.97 111.39 131.97 118.42 113.7 136.69 113.7 129.66 131.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.13 131.97 148.87 131.97 155.9 113.7 174.16 113.7 167.13 131.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.13 142.65 174.85 134.36 189.4 121.27 205.68 129.56 191.13 142.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 159.65 208.25 151.36 222.8 138.27 239.08 146.56 224.53 159.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.24,0H123.08V49.69H103.35l12.44,12.84,21.93,22.64,5.44,5.61,5.44-5.61,21.93-22.64L183,49.69H163.24V0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFuerzaOff);
export default __webpack_public_path__ + "static/media/ic-fuerza-off.cbcbcb9f30aa896b6be3d20d67aa79a9.svg";
export { ForwardRef as ReactComponent };